/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type KiteAnalyticsTotalAgentCallRequest = {
    period?: KiteAnalyticsTotalAgentCallRequest.period;
};

export namespace KiteAnalyticsTotalAgentCallRequest {

    export enum period {
        D7 = 'D7',
        D30 = 'D30',
        D90 = 'D90',
        ALL = 'ALL',
    }


}

